import { Link } from "react-router-dom"
import styled from "styled-components"

type Props = {
    to: string
}

const Container = styled(Link)``

const NextLink: React.FC<Props> = ({children, to}) => {


    return <Container className='button-next' to={to}>
        {children}
    </Container>
}

export default NextLink;
